import { connect } from 'react-redux';
import _ from '../../../utils/lodash';
import PrivateNavLink from './../../../components/common/PrivateNavLink/PrivateNavLink';
import { checkFeatureAccess as checkFeatureAccessHelper } from '../../../utils/helpers';

const checkAnyFeatureAccess = featureAccessList => featureAccess =>
  checkFeatureAccessHelper(featureAccessList, featureAccess);
const memoizedCheck = _.memoize(checkAnyFeatureAccess);

const mapStateToProps = ({ global: { auth } }) => ({
  checkFeatureAccess: memoizedCheck(auth.featureAccessList),
});

const PrivateNavLinkContainer = connect(
  mapStateToProps,
  null,
  null,
  { pure: false },
)(PrivateNavLink);

export default PrivateNavLinkContainer;
